import React from 'react';
import './Credencial.css';
import foto from './../../Images/foto_no_disponible.jpg';
import { GetData } from './../../Services/CredencialService';

function renderActivo(isActivo) {
  if (isActivo) {
    return (<div className="alert alert-success text-center mt-3" role="alert"> AGENTE ACTIVO </div>);
  } else {
    return (<div className="alert alert-danger text-center mt-3" role="alert">  AGENTE DADO DE BAJA  </div>);
  }  
}

function renderFuncion(funcion) {
  if (!funcion) {
    return ('')
  }
  return (
    <div className="row">
      <div className="label">FUNCIÓN: <b>{ funcion.toUpperCase() }</b></div>
    </div>
  );
}

function renderCredencial(usuario) {
  return (
  <div className="row m-5 m-sm-2">
    <div className="col-sm-12 col-md-3 ">
      <img src={usuario?.urlFoto ? `${process.env.REACT_APP_FILEMANAGER}${usuario.urlFoto}` : foto} alt="foto" className="img"/>
    </div>
    <div className="col-sm-12 col-md-9 ">
      <div className="row">
        <div className="name"> { usuario?.nombresApellidos } </div>
      </div>
      <div className="row">
        <div className="label">OFICINA: <b>{ usuario?.dependenciaJudicial }</b></div>
      </div>            
      { renderFuncion(usuario?.funcion)}
    </div>
  </div> );
}

function Credencial() {
  const usuario = GetData();
  console.log(usuario);
  return (
    <>
      <>{ usuario ? renderCredencial(usuario) : '' }</>
      <>{ usuario?.activo !== undefined ? renderActivo(usuario?.activo) : '' }</>
    </>
  );
}

export default Credencial;